import { IProductOffer } from "features/productDetails/types";
import { mockGetStepContentProductsResponse } from "./getStepContentProducts.mock";
import { ProductIds } from "@fortius/prime-ui";

const createPricingSummaryFields = (
  productId: ProductIds,
  trialNetAmount: number,
  netAmount: number,
  trialProductSalesTypeId: number
) => ({
  productId,
  hasTrial: true,
  trialNetAmount,
  trialVat: trialNetAmount * 0.2,
  trialGrossAmount: trialNetAmount * 1.2,
  trialDurationInDays: 30,
  trialProductSalesTypeId,
  netAmount,
  vat: netAmount * 0.2,
  grossAmount: netAmount * 1.2,
  startInDays: 0,
  todayGrossAmount: trialNetAmount * 1.2,
  futureGrossAmount: netAmount * 1.2,
  joiningFeeSummary: null
});

const createOfferWithDescription = (
  title: string,
  terms: string,
  description = "Put your business before the UK's largest network of construction buyers"
) => ({
  title,
  description,
  terms
});

export const mockBronzeProduct: IProductOffer = {
  ...mockGetStepContentProductsResponse.result.productCards[0],
  ...createPricingSummaryFields(ProductIds.CONSTRUCTIONLINE_BRONZE, 49, 588, 1),
  offer: createOfferWithDescription(
    "Monthly Cost [monthlyAmount]",
    "Billed annually [netAmount] excl VAT\nplus [joiningFeeAmount] one-off joining fee"
  ),
  joiningFee: {
    name: "Joining Fee",
    productId: 17,
    productSalesTypeId: 1,
    netAmount: 100,
    vat: 20
  }
};

export const mockSilverProduct: IProductOffer = {
  ...mockGetStepContentProductsResponse.result.productCards[1],
  ...createPricingSummaryFields(ProductIds.CONSTRUCTIONLINE_SILVER, 62, 739, 24),
  offer: createOfferWithDescription(
    "Monthly Cost [monthlyAmount]",
    "Billed annually [netAmount] excl VAT\nplus [joiningFeeAmount] one-off joining fee"
  ),
  joiningFee: {
    name: "Joining Fee",
    productId: 17,
    productSalesTypeId: 1,
    netAmount: 200,
    vat: 20
  }
};

export const mockGoldProduct: IProductOffer = {
  ...mockGetStepContentProductsResponse.result.recommended,
  ...createPricingSummaryFields(ProductIds.CONSTRUCTIONLINE_GOLD, 75, 900, 47),
  offer: createOfferWithDescription(
    "Monthly Cost [monthlyAmount]",
    "Billed annually [netAmount] excl VAT\nplus [joiningFeeAmount] one-off joining fee"
  ),
  joiningFee: {
    name: "Joining Fee",
    productId: 17,
    productSalesTypeId: 1,
    netAmount: 300,
    vat: 30
  }
};

export const mockPlatinumProduct: IProductOffer = {
  ...mockGetStepContentProductsResponse.result.productCards[3],
  ...createPricingSummaryFields(ProductIds.CONSTRUCTIONLINE_PLATINUM, 254, 3049, 70),
  offer: createOfferWithDescription(
    "Monthly Cost [monthlyAmount]",
    "Billed annually [netAmount] excl VAT\nplus [joiningFeeAmount] one-off joining fee"
  ),
  joiningFee: {
    name: "Joining Fee",
    productId: 17,
    productSalesTypeId: 1,
    netAmount: 400,
    vat: 40
  }
};

export const mockProductsSelection: IProductOffer[] = [
  mockBronzeProduct,
  mockSilverProduct,
  mockGoldProduct,
  mockPlatinumProduct
];

export const mockInviterName =
  mockGetStepContentProductsResponse.result.metadata.invitedByOrganisationName || "Balfour Beatty";

export const createProductWithCurrency = (
  baseProduct: IProductOffer,
  currency: string,
  title?: string
): IProductOffer => ({
  ...baseProduct,
  offer: {
    ...baseProduct.offer,
    title: title || `Monthly Cost [monthlyAmount]`,
    terms: baseProduct.offer.terms
  }
});

export const createProductWithoutBenefits = (baseProduct: IProductOffer): IProductOffer => ({
  ...baseProduct,
  benefits: []
});

export const createProductWithoutBenefitIcons = (baseProduct: IProductOffer): IProductOffer => ({
  ...baseProduct,
  benefitIcons: []
});
